<script>export let direction = "horizontal";
export let margin = 3;
export let color = "gray-100";
export let thickness = "2px";
</script>

<div
  class={`twist-divider ${direction}`}
  style={`
    --margin: var(--twist-core-spacing-${margin});
    --thickness: ${thickness}; 
    --color: var(--twist-theme-divider-color, var(--twist-color-${color}));
  `}
/>

<style>.horizontal {
  display: block;
  margin: var(--margin) 0;
  width: 100%;
  border-top: var(--thickness) solid var(--color);
}

.vertical {
  display: inline-block;
  margin: 0 var(--margin);
  height: inherit;
  align-self: stretch;
  border-left: var(--thickness) solid var(--color);
}</style>
